import React, {useEffect, useRef, useState} from "react";
import {Redirect, useParams} from "react-router-dom";
import ProfileHeader from "../Headers/ProfileHeader";
import {Button, FormLabel, InputGroup, Spinner} from "react-bootstrap";
import {EditableText, EditableTextArea} from "../Shared/EditableWidgets";
import {getOrgInvitedUsers, getOrgUsers, getSignedUrl, postOrg, putOrg, uploadFile} from "../../lib/api";
import {EditButton} from "../Shared/Buttons";
import ListOrgUsers from "./ListOrgUsers";
import {FileDrop} from "react-file-drop";
import {ErrorMessageType} from "../../lib/types";
import FormFileInput from "react-bootstrap/FormFileInput";
import ListOrgInvitedUsers from "./ListOrgInvitedUsers";

function OrgView(props: { cognitoUser: any, realvrUser: any, loadData: any }) {
  const {cognitoUser, realvrUser, loadData} = props;
  // @ts-ignore
  const {orgId} = useParams();
  const orgs = realvrUser.user?.orgs;
  let org: any;
  let currentPath: string;
  if (orgId === 'new') {
    org = {
      name: '',
      description: '',
      imagePath: '',
      scopes: ['org_user_admin']
    };
    currentPath = '/org/new';
  } else {
    org = orgs?.find((org: any) => org.id === orgId)
    currentPath = `/org/${org?.id}`
  }

  useEffect(() => {
      if (orgId === 'new') {
        return
      }

      fetchUsers();
    }, []
  )

  function fetchUsers() {
    fetchOrgUsers();
    fetchOrgInvitedUsers();
  }

  function fetchOrgUsers() {
    getOrgUsers(org).then(response => {
      if (response.ok) {
        response.json().then(json => {
          setUsers(json["orgUsers"]);
        });
      }
    });
  }

  function fetchOrgInvitedUsers() {
    getOrgInvitedUsers(org).then(response => {
      if (response.ok) {
        response.json().then(json => {
          setInvitedUsers(json["orgInvitedUsers"]);
        });
      }
    });
  }

  const [redirectToPath, setRedirectToPath] = useState(currentPath);
  const [isEditing, setIsEditing] = useState(orgId === 'new');
  const [error, setError] = useState<null | ErrorMessageType>(null);
  const [name, setName] = useState(org?.name || "");
  const [users, setUsers] = useState([]);
  const [invitedUsers, setInvitedUsers] = useState([]);
  const [description, setDescription] = useState(org.description || '');
  // const [filesUpload, setFilesUpload] = useState([]);
  const [isUploading, setIsuploading] = useState(false);

  const permissionAdmin = org.scopes.find((scope: string) => scope === "org_user_admin");
  const permissionGuest = org.scopes.find((scope: string) => scope === "org_user_guest");

  const fileInputRef = useRef<HTMLInputElement>(null)

  function onTargetClick() {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  }

  function onDrop(args: any) {
    // setFilesUpload(args);
    uploadFiles(args);
  }

  function uploadProgress(progress: number, total: number) {
    console.log('progress', progress, 'total', total)
  }

  function handleFileInput(e: any) {
    // setFilesUpload(e.target.files);
    uploadFiles(e.target.files);
  }

  function uploadFiles(files: any) {
    if (!permissionAdmin) {
      setError({message: "You are not an admin of this organization"});
      return;
    }
    if (!org.id) {
      setError({message: "Please save new organization first"});
      return;
    }
    setError(null);
    const file: any = files[0];
    if (!file.type.startsWith("image/")) {
      setError({message: "Please upload a png or jpeg image"});
      return
    }
    setIsuploading(true);
    getSignedUrl(file).then((response) => {
      response.json().then(json => {
        // setFileMessage(`Uploading file ${file.name} ${i+1} of ${files.length}`)
        uploadFile(json.postUrl, file, uploadProgress)
          .then(uploadResponse => {
            putOrg({imageUrl: json.getUrl, logoUrl: null, imageAttributes: {}}, org.id).then(orgResponse => {
              setIsuploading(false);
              if (orgResponse.ok) {
                loadData();
              } else {
                orgResponse.json().then(json => {
                  console.log("error json", json);
                  setError(json?.error);
                });
              }
            })
          }).catch(error => {
          setIsuploading(false);
          setError({message: "Error uploading"})
        })
      })
    });
  }

// Check if org
  if (!org && orgId !== 'new') {
    return <Redirect to="/home"/>
  }

  function saveSuccess(response: any) {
    setError(null);
    setIsEditing(false);
    response.json().then((json: any) => {
      loadData().then(() => {
        if (currentPath === '/org/new') {
          const path = `/org/${json?.org?.id}/villas`
          setRedirectToPath(path);
        }
      });
    })
  }

  function saveError(json: any) {
    setError(json?.error);
  }

  function save() {
    const method = org.id ? putOrg : postOrg;
    method({name, description}, org.id)
      .then((response) => {
        if (response.ok) {
          saveSuccess(response);
        } else {
          response.json().then(json => {
            saveError(json);
          })
        }
      })
      .catch((err: any) => {
        console.log(err)
        saveError({message: 'An error occurred, please try again'} as any);
      });
  }

  function cancel() {
    setName(org.name);
    setDescription(org.description);
    setError(null);
    setIsEditing(false);
    if (orgId === 'new') {
      setRedirectToPath('/home');
    }
  }

  if (redirectToPath !== currentPath) {
    return <Redirect to={redirectToPath}/>
  }

  const title = (org.id ? '' : 'New ') + "Organization";

  const buttons = isEditing
    ? <div className="col-12 py-1 text-right">
      <Button
        onClick={cancel}
        variant="secondary">
        Cancel
      </Button>
      <Button
        onClick={save}
        variant="primary">
        Save
      </Button>
    </div>
    : <div className="col-12 text-right">
      <EditButton onClick={() => setIsEditing(true)} visible={permissionAdmin && !isEditing}/>
    </div>;

  const errorMessage =
    error ?
      <div className="row pb-3 error">
        <div className="col-12 text-center">
          {(error as any)?.message}
        </div>
      </div>
      : null;

  // const imageStyle = {
  //   backgroundImage: `url("${org.imageUrl}")`,
  //   backgroundSize: "cover"
  // };

  const linkToHome = org.id ? `/org/${org.id}/villas` : '/home';
  const homeImage = org.id ? org.imageUrl : null;

  return (
    <>
      <ProfileHeader cognitoUser={cognitoUser} title={title} linkToHome={linkToHome} image={homeImage}/>
      <InputGroup>
        <section className="container main view-org rounded pt-1 pb-4 mt-0 mt-md-3">
          {errorMessage}
          <div className="row">
            {buttons}
          </div>
          <div className="row px-3 py-0 d-md-none">
            <div className="col-md-12 px-0 py-0">
              <FormLabel className="mb-0 h-auto">Name</FormLabel>
            </div>
          </div>
          <div className="row px-3 py-2">
            <div className="d-none d-md-block col-md-2 text-right">
              <FormLabel>Name</FormLabel>
            </div>
            <div className="col-12 col-md-4 px-0">
              <div className="row">
                <div className="col">
                  <EditableText
                    value={name}
                    maxLength={40}
                    onChange={(event: any) => setName(event.target.value)}
                    isEditable={permissionAdmin}
                    isEditing={isEditing}
                    setIsEditing={setIsEditing}
                    placeholder="Name, i.e. RealVR"
                    ariaLabel="Name"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row px-3 pt-2 pb-0 d-md-none">
            <div className="col-md-12 px-0 pb-0">
              <FormLabel className="mb-0 h-auto">Motto</FormLabel>
            </div>
          </div>
          <div className="row px-3 py-2">
            <div className="d-none d-md-block col-md-2 text-right">
              <FormLabel>Motto</FormLabel>
            </div>
            <div className="col-12 col-md-4 px-0">
              <div className="row">
                <div className="col">
                  <EditableTextArea
                    value={description}
                    maxLength={120}
                    rows={3}
                    onChange={(event: any) => setDescription(event.target.value)}
                    isEditable={permissionAdmin}
                    isEditing={isEditing}
                    setIsEditing={setIsEditing}
                    placeholder="Motto, i.e. Metaverse Terraforming Platform"
                    ariaLabel="Motto"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row px-3 pt-2 pb-0 d-md-none">
            <div className="col-md-12 px-0 pb-0">
              <FormLabel className="mb-0 h-auto">Logo</FormLabel>
            </div>
          </div>
          <div className="row px-3 py-2">
            <div className="d-none d-md-block col-md-2 text-right">
              <FormLabel>Logo</FormLabel>
            </div>
            <div className="col-12 col-md-4 px-0">
              <FormFileInput className="d-none"
                             ref={fileInputRef}
                             type="file"
                             onChange={handleFileInput}
                             accept="image/*"
                             multiple/>
              {org.imageUrl ?
                <FileDrop className={`border ${isUploading ? 'file-drop' : ''}`} onTargetClick={onTargetClick}
                          onDrop={onDrop}>
                  {isUploading ? <Spinner animation="border"/> : <img src={org.imageUrl} alt={org.name} width="100%"/>}
                </FileDrop>
                :
                <FileDrop className="file-drop border" onTargetClick={onTargetClick} onDrop={onDrop}>
                  {isUploading ? <Spinner animation="border"/> : "Drag & drop image or click"}
                </FileDrop>
              }
            </div>
          </div>
          <div className="row px-3 pt-2 pb-0 d-md-none">
            <div className="col-md-12 px-0 pb-0">
              <FormLabel className="mb-0 h-auto">Members</FormLabel>
            </div>
          </div>
          <div className="row px-3 py-2">
            <div className="d-none d-md-block col-md-2 text-right">
              <FormLabel>Members</FormLabel>
            </div>
            <div className="col-12 col-md-8 px-0">
              <ListOrgUsers
                org={org}
                users={users}
                permissionGuest={permissionGuest}
                permissionAdmin={permissionAdmin}
                loadData={fetchUsers}/>
            </div>
          </div>
          <div className="row px-3 py-2">
            <div className="d-none d-md-block col-md-2 text-right">
              <FormLabel>Invited</FormLabel>
            </div>
            <div className="col-12 col-md-8 px-0">
              <ListOrgInvitedUsers
                org={org}
                invitedUsers={invitedUsers}
                permissionAdmin={permissionAdmin}
                loadData={fetchUsers}/>
            </div>
          </div>
        </section>
      </InputGroup>
    </>
  );
}

export default OrgView;
